import { z } from 'zod';

export const CoreDataFilterScalarFieldEnumSchema = z.enum(['id','filterGroupId','order','field','fieldId','type','fieldTable','numberCondition','stringCondition','booleanCondition','dateCondition','dropdownCondition','integerValue','secondIntegerValue','floatValue','secondFloatValue','stringValue','booleanValue','startDateValue','endDateValue','jsonValue']);

export default CoreDataFilterScalarFieldEnumSchema;
